import Routers from "./Router/Routes";

function App() {
  return <Routers />;
}

export default App;
